var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"videoss"},[_c('div',{style:({
      background: _vm.datas.backColor,
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    })},[(!_vm.datas.videoUrl)?_c('section',{staticClass:"default"},[_c('img',{staticClass:"full_img",attrs:{"draggable":"false","src":_vm.defaultImg,"alt":""}})]):_c('section',{staticStyle:{"position":"relative"}},[_c('video',{attrs:{"src":_vm.datas.videoUrl,"controls":"","loop":_vm.datas.loopplay,"autoplay":_vm.datas.autoplay,"poster":_vm.datas.coverUrl,"width":"100%"}})])]),_vm._t("deles")],2)}
var staticRenderFns = []

export { render, staticRenderFns }